import axios from 'axios';
import { initRecaptcha } from '@js/routes/check-email';

const PremiumServicesModal = () => {
  const btn = document.querySelector('.js-openPremiumServicesModal');
  const close = document.querySelector('.js-closePremiumServicesModal');
  const form = document.getElementById('PremiumServicesForm');
  const wrapper = document.getElementById('PremiumServicesModalWrapper');
  const overlay = document.getElementById('PremiumServicesModal');
  const alert = document.getElementById('js-error-PremiumServicesForm');

  if(!btn || !overlay || !form) return null;

  btn.addEventListener('click', () => {
    overlay.classList.add('open');
    document.body.classList.add('overflow-hidden');
    close.focus();
  })

  close?.addEventListener('click', () => {
    overlay.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if(form.checkValidity() === false) return null;

    wrapper.classList.add('is-loading');

    try {
      const response = await axios.post(`/open_api/landing_premium_services`, new FormData(form));


      if(response.status === 200) {
        alert.classList.add('hidden');

        if(response.data.logged) {
          window.open('/landing_hdi_success', '_blank');
          overlay.classList.remove('open');
          document.body.classList.remove('overflow-hidden');
          return;
        }

        loadCheckEmail(wrapper,overlay);
      }

    } catch (error) {
      alert.classList.remove('hidden');
    }

    wrapper.classList.remove('is-loading');
  })
}


async function loadCheckEmail(wrapper,overlay) {

  try {
		const { data } = await axios.get(`/check-email?services=1`);
		const parser = new DOMParser();
		const page = parser.parseFromString(data, 'text/html');
    const section = page.getElementById('CheckEmail');
    const form = page.getElementById('check-email');
    form?.setAttribute('target','_blank');

		wrapper.innerHTML = '';
    wrapper.appendChild(section);
    initRecaptcha();

    form?.addEventListener('submit', () => {
      overlay.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    })


	} catch (e) {
		console.error(e);
	}
}

export default PremiumServicesModal;
